'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useMemo, useState } from 'react';
import useSWR from 'swr';
import { useMediaQuery } from 'usehooks-ts';
import EmptyFavoriteCard from '@/app/[locale]/(worlds)/profile/components/EmptyFavoriteCard';
import LoadMoreButton from '@/components/LoadMoreButton';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useDraggingScroll } from '@/hooks/useDraggingScroll';
import { usePagination } from '@/hooks/usePagination';
import { useScrollable } from '@/hooks/useScrollable';
import { cn } from '@/lib/utils';
import { getCardType } from '@/lib/viverse-world-card';
import { getLikedRooms, PaginationPages, Room } from '@/services/cms';
const LIMIT = 12;
function UserFavorite() {
  const $ = _c(38);
  const t = useTranslations();
  const {
    store
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  let t0;
  if ($[0] !== htcToken) {
    t0 = () => getLikedRooms(htcToken, {
      start: 0,
      limit: LIMIT
    }).then(_temp);
    $[0] = htcToken;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: likedRoomsData
  } = useSWR("likedRooms", t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [lists, setLists] = useState(t1);
  const pages = likedRoomsData?.pages as PaginationPages;
  const total = pages?.total;
  const stopScroll = useMediaQuery("(min-width: 1440px)");
  const {
    containerRef,
    canScrollLeft,
    canScrollRight
  } = useScrollable(300, stopScroll);
  const {
    bind,
    disableDrag,
    onMouseDown,
    onMouseUp
  } = useDraggingScroll(containerRef);
  const {
    isLoading: isPaginatedDataLoading,
    onPaginateStart,
    onPaginateComplete,
    start
  } = usePagination(pages?.start, total);
  const enableLoadMore = start + LIMIT < total;
  let t2;
  if ($[3] !== likedRoomsData?.results || $[4] !== lists) {
    const likedRooms = likedRoomsData?.results || [];
    t2 = [...likedRooms, ...lists].filter(_temp2);
    $[3] = likedRoomsData?.results;
    $[4] = lists;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const combinedRooms = t2;
  let t3;
  if ($[6] !== htcToken || $[7] !== onPaginateComplete || $[8] !== onPaginateStart || $[9] !== start || $[10] !== total) {
    t3 = async function handleLoadMore() {
      onPaginateStart();
      const res_0 = await getLikedRooms(htcToken, {
        start: start + LIMIT,
        limit: LIMIT
      });
      if (res_0?.status === 200 && res_0.results.results) {
        setLists(lists_0 => [...lists_0, ...res_0.results.results]);
        onPaginateComplete(start + LIMIT, res_0.results?.pages?.total);
      } else {
        onPaginateComplete(start, total);
      }
    };
    $[6] = htcToken;
    $[7] = onPaginateComplete;
    $[8] = onPaginateStart;
    $[9] = start;
    $[10] = total;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleLoadMore = t3;
  let t4;
  if ($[12] !== t) {
    t4 = t("profile-page.favorite-section-title");
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <h2 className="subheader-1 md:header-4 relative font-bold">{t4}</h2>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== bind) {
    t6 = bind();
    $[16] = bind;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = !disableDrag && (canScrollLeft || canScrollRight);
  const t8 = !disableDrag && (canScrollLeft || canScrollRight);
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = cn("no-scrollbar flex w-full flex-col gap-6 select-none max-lg:overflow-x-auto max-lg:scroll-smooth md:gap-9", {
      "active:cursor-grabbing": t7,
      "cursor-grab": t8
    });
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== combinedRooms) {
    t10 = combinedRooms.length > 0 ? <><div className="flex gap-5 md:-mx-2 md:gap-2 lg:flex-wrap lg:gap-2">{combinedRooms.map(_temp3)}</div></> : <EmptyFavoriteCard />;
    $[21] = combinedRooms;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== containerRef || $[24] !== onMouseDown || $[25] !== onMouseUp || $[26] !== t10 || $[27] !== t6 || $[28] !== t9) {
    t11 = <div {...t6} ref={containerRef} className={t9} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>{t10}</div>;
    $[23] = containerRef;
    $[24] = onMouseDown;
    $[25] = onMouseUp;
    $[26] = t10;
    $[27] = t6;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== enableLoadMore || $[31] !== handleLoadMore || $[32] !== isPaginatedDataLoading) {
    t12 = enableLoadMore && <div className="flex flex-1 justify-center"><LoadMoreButton isLoading={isPaginatedDataLoading} onClick={handleLoadMore} /></div>;
    $[30] = enableLoadMore;
    $[31] = handleLoadMore;
    $[32] = isPaginatedDataLoading;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t11 || $[35] !== t12 || $[36] !== t5) {
    t13 = <div id="favorites" className="relative flex scroll-mt-40 flex-col gap-6 px-4 md:gap-9 md:px-8 lg:px-18">{t5}{t11}{t12}</div>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t5;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
}
function _temp3(room_0, index_0) {
  return <ViverseWorldCard className="max-w-[306px] min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]" key={`followings-card-${room_0.id}-${index_0}`} info={room_0} hidePremiumBadge={false} cardType={getCardType(room_0.content_type)} />;
}
function _temp2(room, index, self) {
  const isDuplicate = self.findIndex(t_0 => t_0.id === room.id) !== index;
  return !isDuplicate;
}
function _temp(res) {
  return res?.results;
}
export default UserFavorite;